import { observer } from 'mobx-react';
import React, { useMemo } from 'react';

import { SEARCH_TYPE_COOKIE } from 'app/constants';
import useIsMobile from 'hooks/use-is-mobile';
import useStores from 'hooks/use-stores';
import SearchBar from 'main/components/SearchBar';
import DrawerMenuButton from 'pages/layout/components/DrawerMenuButton';
import Logo from 'pages/layout/components/Logo';
import UpgradeLicenseButton from 'pages/layout/components/UpgradeLicenseButton';
import { getCookie } from 'utils/cookies';
import isBrowser from 'utils/is-browser';

import useStyles from './styles';

const Header = () => {
    const { classes } = useStyles();
    const { searchStore } = useStores();
    const isMobile = useIsMobile();

    useMemo(() => {
        if (isBrowser()) {
            const type = getCookie(SEARCH_TYPE_COOKIE);
            if (type) {
                searchStore.setType(type);
            }
        }
    }, [searchStore]);

    return (
        <div className={classes.container}>
            <div className={classes.logoBox}>
                <Logo />
            </div>
            {isMobile ? null : <SearchBar className={classes.searchBarRoot} />}
            <div className={classes.buttons}>
                <UpgradeLicenseButton />
                {isMobile ? <DrawerMenuButton className={classes.menuButton} /> : null}
            </div>
        </div>
    );
};

export default observer(Header);
